import React from 'react';
import { IoKeySharp } from 'react-icons/io5';
 
export const AddApiKeysTab = ({ setActiveTab, activeTab }) => {
  return (
    <>
      <li className="nav-item">
        <button
          className={`nav-link ${activeTab === 'addApiKeys' ? 'active' : ''}`}
          onClick={() => setActiveTab('addApiKeys')}
        >
          <span style={{ marginRight: '5px', fontSize: '20px' }}><IoKeySharp /> </span>
          API Keys
        </button>
      </li>
    </>
  );
};